// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-payment-form {
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  border: 1px solid #e8e8e8;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.new-payment-form .form-group {
  margin-bottom: 20px;
}
.new-payment-form .form-group label {
  font-weight: 600;
  color: #1a1a1a;
  font-size: 0.875rem;
  margin-bottom: 8px;
  display: block;
}
.new-payment-form .form-control,
.new-payment-form .form-select {
  border: 2px solid #e8e8e8;
  border-radius: 10px;
  padding: 12px 16px;
  font-size: 0.9375rem;
  color: #1a1a1a;
  transition: all 0.3s ease;
  background-color: #f9fafb;
}
.new-payment-form .form-control:focus,
.new-payment-form .form-select:focus {
  border-color: #667eea;
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  outline: none;
}
.new-payment-form .form-control::placeholder,
.new-payment-form .form-select::placeholder {
  color: #9ca3af;
}
.new-payment-form .form-control.is-invalid,
.new-payment-form .form-select.is-invalid {
  border-color: #ef4444;
  background-color: #fef2f2;
}
.new-payment-form .form-control.is-invalid:focus,
.new-payment-form .form-select.is-invalid:focus {
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}
.new-payment-form .invalid-feedback {
  color: #ef4444;
  font-size: 0.8125rem;
  margin-top: 6px;
  display: block;
  font-weight: 500;
}
.new-payment-form .input-icon {
  display: flex;
  align-items: center;
  position: relative;
}
.new-payment-form .input-icon svg {
  position: absolute;
  left: 16px;
  color: #6b7280;
  z-index: 1;
}
.new-payment-form .input-icon .form-control {
  padding-left: 48px;
}
.new-payment-form .btn-block {
  width: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  font-size: 1rem;
  font-weight: 600;
  padding: 14px 24px;
  border-radius: 10px;
  color: white;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}
.new-payment-form .btn-block:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}
.new-payment-form .btn-block:active {
  transform: translateY(0);
}
.new-payment-form .btn-block:disabled {
  background: #d1d5db;
  cursor: not-allowed;
  transform: none;
}
.new-payment-form .alert-danger {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fecaca;
  border-radius: 10px;
  color: #991b1b;
  font-size: 0.875rem;
  padding: 12px 16px;
  margin-top: 16px;
  font-weight: 500;
}
.new-payment-form .form-check-remember {
  display: flex;
  align-items: center;
  margin: 16px 0;
}
.new-payment-form .form-check-remember .form-check-input {
  width: 18px;
  height: 18px;
  margin-right: 10px;
  border: 2px solid #d1d5db;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.new-payment-form .form-check-remember .form-check-input:checked {
  background-color: #667eea;
  border-color: #667eea;
}
.new-payment-form .form-check-remember .form-check-input:focus {
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
.new-payment-form .form-check-remember .form-check-label {
  color: #4b5563;
  font-size: 0.9375rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.new-payment-form .form-select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 12px center;
  background-repeat: no-repeat;
  background-size: 20px;
  padding-right: 40px;
}

.form-section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f3f4f6;
}
.form-section-header i {
  color: #667eea;
  font-size: 1.25rem;
}
.form-section-header h6 {
  margin: 0;
  font-weight: 600;
  color: #1a1a1a;
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/Student/PaymentForm/NewPaymentForm.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,yCAAA;AACF;AACE;EACE,mBAAA;AACJ;AACI;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AACN;AAGE;;EAEE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;AADJ;AAGI;;EACE,qBAAA;EACA,yBAAA;EACA,8CAAA;EACA,aAAA;AAAN;AAGI;;EACE,cAAA;AAAN;AAGI;;EACE,qBAAA;EACA,yBAAA;AAAN;AAEM;;EACE,4CAAA;AACR;AAIE;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAFJ;AAKE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAHJ;AAKI;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,UAAA;AAHN;AAMI;EACE,kBAAA;AAJN;AAQE;EACE,WAAA;EACA,6DAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,+CAAA;AANJ;AAQI;EACE,2BAAA;EACA,+CAAA;AANN;AASI;EACE,wBAAA;AAPN;AAUI;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;AARN;AAYE;EACE,6DAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAVJ;AAaE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;AAXJ;AAaI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAXN;AAaM;EACE,yBAAA;EACA,qBAAA;AAXR;AAcM;EACE,8CAAA;AAZR;AAgBI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAdN;AAmBE;EACE,gBAAA;EACA,yDAAA;EACA,sCAAA;EACA,4BAAA;EACA,qBAAA;EACA,mBAAA;AAjBJ;;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AAnBF;AAqBE;EACE,cAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,SAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AApBJ","sourcesContent":[".new-payment-form {\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 24px;\n  border: 1px solid #e8e8e8;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n\n  .form-group {\n    margin-bottom: 20px;\n\n    label {\n      font-weight: 600;\n      color: #1a1a1a;\n      font-size: 0.875rem;\n      margin-bottom: 8px;\n      display: block;\n    }\n  }\n\n  .form-control,\n  .form-select {\n    border: 2px solid #e8e8e8;\n    border-radius: 10px;\n    padding: 12px 16px;\n    font-size: 0.9375rem;\n    color: #1a1a1a;\n    transition: all 0.3s ease;\n    background-color: #f9fafb;\n\n    &:focus {\n      border-color: #667eea;\n      background-color: #ffffff;\n      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n      outline: none;\n    }\n\n    &::placeholder {\n      color: #9ca3af;\n    }\n\n    &.is-invalid {\n      border-color: #ef4444;\n      background-color: #fef2f2;\n\n      &:focus {\n        box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n      }\n    }\n  }\n\n  .invalid-feedback {\n    color: #ef4444;\n    font-size: 0.8125rem;\n    margin-top: 6px;\n    display: block;\n    font-weight: 500;\n  }\n\n  .input-icon {\n    display: flex;\n    align-items: center;\n    position: relative;\n\n    svg {\n      position: absolute;\n      left: 16px;\n      color: #6b7280;\n      z-index: 1;\n    }\n\n    .form-control {\n      padding-left: 48px;\n    }\n  }\n\n  .btn-block {\n    width: 100%;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    border: none;\n    font-size: 1rem;\n    font-weight: 600;\n    padding: 14px 24px;\n    border-radius: 10px;\n    color: white;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);\n    }\n\n    &:active {\n      transform: translateY(0);\n    }\n\n    &:disabled {\n      background: #d1d5db;\n      cursor: not-allowed;\n      transform: none;\n    }\n  }\n\n  .alert-danger {\n    background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n    border: 1px solid #fecaca;\n    border-radius: 10px;\n    color: #991b1b;\n    font-size: 0.875rem;\n    padding: 12px 16px;\n    margin-top: 16px;\n    font-weight: 500;\n  }\n\n  .form-check-remember {\n    display: flex;\n    align-items: center;\n    margin: 16px 0;\n\n    .form-check-input {\n      width: 18px;\n      height: 18px;\n      margin-right: 10px;\n      border: 2px solid #d1d5db;\n      border-radius: 4px;\n      cursor: pointer;\n      transition: all 0.2s ease;\n\n      &:checked {\n        background-color: #667eea;\n        border-color: #667eea;\n      }\n\n      &:focus {\n        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n      }\n    }\n\n    .form-check-label {\n      color: #4b5563;\n      font-size: 0.9375rem;\n      cursor: pointer;\n      user-select: none;\n    }\n  }\n\n  // Pricing option select styling\n  .form-select {\n    appearance: none;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e\");\n    background-position: right 12px center;\n    background-repeat: no-repeat;\n    background-size: 20px;\n    padding-right: 40px;\n  }\n}\n\n// Form section header\n.form-section-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n  padding-bottom: 12px;\n  border-bottom: 2px solid #f3f4f6;\n\n  i {\n    color: #667eea;\n    font-size: 1.25rem;\n  }\n\n  h6 {\n    margin: 0;\n    font-weight: 600;\n    color: #1a1a1a;\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
